import React from 'react'

export default function AuthInitializedGate(props) {
  const { loading, children } = props
  return loading ? null : <>{children}</>
}
